var ImageLightboxModule = /** @class */ (function () {
    function ImageLightboxModule() {
    }
    return ImageLightboxModule;
}());
export { ImageLightboxModule };
